import React from 'react';
import ReactDOM from 'react-dom';

interface DialogMeteringDeviceAdditionalProps {
 isOpen: boolean;
 onClose: () => void;
}

export const DialogMeteringDeviceAdditionalRequest: React.FC<
 DialogMeteringDeviceAdditionalProps
> = ({ isOpen, onClose }) => {
 if (!isOpen) return null;

 return ReactDOM.createPortal(
  <div style={styles.overlay}>
   <div style={styles.modalCard}>
    <div style={styles.header}>
     <div style={styles.circleIcon}>
      <div style={styles.checkmark}></div>
     </div>
     <h2 style={styles.title}>Заявка</h2>
    </div>

    <div style={styles.content}>
     <p style={styles.text}>
      На прибор учета отправлена заявка на снятие показаний. Показания будут
      получены через несколько минут. Чтобы их увидеть, нажмите кнопку обновить
      в блоке "Показания ПУ"
     </p>
    </div>

    <div style={styles.actions}>
     <button style={styles.button} onClick={onClose}>
      ОК
     </button>
    </div>
   </div>
  </div>,
  document.body,
 );
};

const styles: Record<string, React.CSSProperties> = {
 overlay: {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.15)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99999,
  fontFamily:
   '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
 },
 modalCard: {
  backgroundColor: '#ffffff',
  borderRadius: '4px',
  padding: '24px 32px 24px 24px',
  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
  width: '100%',
  maxWidth: '460px',
  boxSizing: 'border-box',
  border: '2px solid #000000', // Черная рамка 2px
 },
 header: { display: 'flex', alignItems: 'center', marginBottom: '14px' },
 circleIcon: {
  position: 'relative',
  width: '22px',
  height: '22px',
  borderRadius: '50%',
  border: '2px solid #68C154',
  marginRight: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
 },
 checkmark: {
  position: 'absolute',
  top: '3px',
  left: '7px',
  width: '4px',
  height: '9px',
  borderRight: '2px solid #68C154',
  borderBottom: '2px solid #68C154',
  transform: 'rotate(45deg)',
  boxSizing: 'border-box',
 },
 title: { margin: 0, fontSize: '20px', fontWeight: '600', color: '#2C3539' },
 content: { marginBottom: '24px', paddingLeft: '34px' },
 text: {
  margin: 0,
  fontSize: '14px',
  lineHeight: '1.5',
  color: '#5E6468',
  letterSpacing: '-0.1px',
 },
 actions: { display: 'flex', justifyContent: 'flex-end' },
 button: {
  backgroundColor: '#00AEF0',
  color: '#ffffff',
  border: 'none',
  borderRadius: '20px',
  padding: '10px 32px',
  fontSize: '14px',
  fontWeight: '600',
  cursor: 'pointer',
  outline: 'none',
  transition: 'background-color 0.2s ease',
 },
};
